import {React, Component, Link} from 'utils';
import {App} from 'model'
import Hammer from 'react-hammerjs';
import './swiper-full.less';
import { debug } from 'util';
import {Creators} from "../../model";

const swiperClass = 'swiper';

export default class Swiper extends Component {

	constructor(props) {
		super(props);

		this.state = {
			active: 0,
			id: 'slider-full-' + Math.round(Math.random() * 1000000),
			items: this.props.items
		};

		this.offset = 0;
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			items: nextProps.items
		})
	}

	findPreviousIndex(active, total) {
		if (active > 0) {
			return active - 1;
		} else {
			return -1;
		}
	}

	findNextIndex(active, total) {
		if (active < total - 1) {
			return active + 1;
		} else {
			return -1;
		}
	}

	handleSwipe = (args) => {
		var {direction} = args;
		var {items} = this.state;

		var {active} = this.state;
		var count = items.length;

		Creators.gallerySwiped();

		if (direction == 2) {
			//swipe left
			var next = this.findNextIndex(active, count);

			if (next == -1) {
				next = count - 1;
			}

			this.setState({
				active: next
			});
		} else if (direction == 4) {
			//swipe right
			var previous = this.findPreviousIndex(active, count);

			if (previous == -1) {
				previous = active;
			}

			this.setState({
				active: previous
			});
		}
	};

	componentDidMount() {
		var {id} = this.state;
		var slider = $('#' + id);
		this.repositionSlides(slider);

		this.timer = null;
		$(window).on('resize', this.handleResizeTimer);
		$(window).on('dragstart', (event) => {
			event.preventDefault();
		});
		this.handleResize();
	}

	componentWillMount()
	{
		document.addEventListener("keydown", this.handleArrows);
	}

	componentWillUnmount()
	{
		$('body').removeClass(swiperClass);
		$(window).off('resize', this.handleResizeTimer);
		$(window).off('dragstart', (event) => {
			event.preventDefault();
		});
		document.removeEventListener("keydown", this.handleArrows);
	}

	handleArrows = (event) => {
		if (event.keyCode === 37)
			this.handleSwipe({direction: 4});
		if (event.keyCode === 39)
			this.handleSwipe({direction: 2});
	};

	handleResizeTimer = () => {
		clearTimeout(this.timer);
		this.timer = setTimeout(this.handleResize, 200);
	};

	handleResize = () => {
		this.setupBody(true);
	};

	repositionSlides(slider) {

		var active = $('.active', slider);
		var slides = $('.slides', slider);

		var width = slider.width();
		var scaledWidth = width * 1;
		var offset = (width - scaledWidth) / 2;

		var {active} = this.state;

		this.offset = 0 - active * scaledWidth;

		slides.animate({
			left: this.offset
		})
	}

	setupBody = (reposition) => {
		var {id} = this.state;
		var slider = $('#' + id);

		var {items} = this.props;

		if (items.length > 0) {
			if (!$('body').hasClass(swiperClass)) {
				$('body').addClass(swiperClass);
			}

			if (reposition) {
				this.repositionSlides(slider);
			}

		} else {
			$('body').removeClass(swiperClass);
		}
	};

	componentDidUpdate() {
		this.setupBody(true);
	}

	renderPager(current, total) {
		return (
			<div className="pager">
				<i
					className="fa fa-angle-left"
					aria-hidden="true"
					onClick={() => this.handleSwipe({ direction: 4 })}
				/>
				<span className="numbers">
					{current}/{total}
				</span>
				<i
					className="fa fa-angle-right"
					aria-hidden="true"
					onClick={() => this.handleSwipe({ direction: 2 })}
				/>
			</div>
		)
	}

	render() {
		var {slide, backUrl} = this.props;
		var {items} = this.state;
		var top, slides = null;
		var {active, id} = this.state;

		var src = App.resourceUrl('close-white.svg');

		if (items.length > 0) {

			var count = items.length;
			var next = this.findNextIndex(active, count);
			var prev = this.findPreviousIndex(active, count);


			slides = items.map((item, index) => {

				var css = ['slide'];

				if (active == index) {
					css.push('active');
				}

				if (prev == index) {
					css.push('previous');
				}

				if (next == index) {
					css.push('next');
				}

				return (
					<div key={ item.id } className={ css.join(' ') }>
						{ slide(item) }
					</div>
				);
			});

			top = (
				<div className="info-overlay top">
					{this.renderPager(active + 1, items.length)}
				</div>
			);

			this.setupBody(false);
		} else {
			return (
				<div className="slider full empty">
					<div className="info-overlay top">
						<span className="numbers">0/0</span>
					</div>
				</div>
			);
		}

		this.offset = isNaN(this.offset) ? 0 : this.offset;

		return <Hammer onSwipe={ this.handleSwipe }>
			<div id={id} className="slider full">
				{top}
				<div className="slides" style={{left: this.offset}}>
					{slides}
				</div>
			</div>
		</Hammer>;
	}
}

export function Element({item}) {
	return item.content;
}



// WEBPACK FOOTER //
// ./src/modules/components/activities/swiper-full.js